var _defs, _g, _path, _g2, _path2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlansimAuthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 660,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 346.08 342.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-4{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442);}.cls-4{stroke:#000;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#2d2b2c;}\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(59.65 71.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87,47.41a5.65,5.65,0,0,0-5.66,5.66v17h66.89a8.5,8.5,0,0,1,8.51,8.5v73.84l55.84,32.24V47.41Zm-72.85-.07V70.11L70,102.35V53.07a5.66,5.66,0,0,0-5.67-5.66H15.1c-.23,0-.44,0-.66-.07ZM25.09,14.17A10.92,10.92,0,0,0,14.17,25.09V36H64.35A5.67,5.67,0,0,0,70,30.33V14.17Zm56.27,0V30.33A5.66,5.66,0,0,0,87,36H212.6V25.09a10.92,10.92,0,0,0-10.92-10.92Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442",
    y1: 267.87,
    x2: 1,
    y2: 267.87,
    gradientTransform: "matrix(246.91, 0, 0, -246.91, -10.07, 66239.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2d2b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#2d2b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#263c47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#1c5670"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#146d94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#0c7fb1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#078dc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0397d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#019de0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009fe3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(59.65 71.75)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 226.77,
    height: 267.87
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -10.05,
    y: -29.12,
    width: 246.86,
    height: 257.09,
    transform: "translate(30.25 219.65) rotate(-60)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70,218.27",
    transform: "translate(59.65 71.75)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M189.64,252.73V236.1h-1.21l8.54,14h2.57l8.36-14h-1l0,16.63h5.41l0-24.92h-4.77l-10.43,17.58h2.53L189,227.81h-4.77v24.92Zm-29.19,0,11.89-16.2v16.2H178V227.81h-5.42L160.73,244V227.81H155v24.92ZM146.83,252a11.57,11.57,0,0,0,4.4-3.32l-3.7-3.41a8.57,8.57,0,0,1-2.85,2.22,8,8,0,0,1-3.42.73,8.71,8.71,0,0,1-3.2-.57,7.09,7.09,0,0,1-2.53-1.64,7.63,7.63,0,0,1-1.66-2.52,9.34,9.34,0,0,1,0-6.48,7.67,7.67,0,0,1,1.66-2.53,7.23,7.23,0,0,1,2.53-1.64,8.71,8.71,0,0,1,3.2-.57,8.13,8.13,0,0,1,3.42.73,8.87,8.87,0,0,1,2.85,2.19l3.7-3.42a11.5,11.5,0,0,0-4.4-3.29,14.64,14.64,0,0,0-5.85-1.12,15.09,15.09,0,0,0-5.38.94,12.84,12.84,0,0,0-4.29,2.69,12.4,12.4,0,0,0-2.85,4.1,13.69,13.69,0,0,0,0,10.32,12.46,12.46,0,0,0,7.12,6.78,15.84,15.84,0,0,0,11.25-.19m-29.24-14.39H105.41v4.88h12.18Zm-11.75-9.82h-5.77v24.92h5.77Zm11.32,24.92h5.77V227.81h-5.77Zm-26.88-5.34L88.72,243H75.9l-1.53,4.38Zm-15.56,5.34,9.15-22H81.6l9.11,22h6.05L85.62,227.81h-5.7l-11.1,24.92ZM47,252.09a6.85,6.85,0,0,0,2.24-3,19.75,19.75,0,0,0,1.21-4.84,61.38,61.38,0,0,0,.5-6.52l.21-6.58L50,232.51H61l-1.32-1.32v21.54h5.7V227.81H46.24l-.35,10.11a46.26,46.26,0,0,1-.46,5.44,8.4,8.4,0,0,1-1.18,3.44A2.59,2.59,0,0,1,42,248a3.56,3.56,0,0,1-1-.14l-.36,4.88c.55.12,1.05.21,1.52.28a8.94,8.94,0,0,0,1.33.11,6,6,0,0,0,3.6-1m-26.84.64V231.19l-1.32,1.32H32.75l-1.31-1.32v21.54h5.73V227.81H14.45v24.92Z",
    transform: "translate(59.65 71.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M70,108.14",
    transform: "translate(59.65 71.75)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70,108.14",
    transform: "translate(59.65 71.75)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M70,209.76a8.51,8.51,0,0,1-8.51,8.51H22.68a8.51,8.51,0,0,1-8.51-8.51V83.2L70,115.44Zm86.74-44.22v44.22a8.5,8.5,0,0,0,8.5,8.51h38.83a8.51,8.51,0,0,0,8.51-8.51v-12l-55.84-32.21",
    transform: "translate(59.65 71.75)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlansimAuthLogo);
export default __webpack_public_path__ + "static/media/plansim-auth-logo.c89d69366d5fc04fb77ab52a105fe17c.svg";
export { ForwardRef as ReactComponent };